import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

/**
  * Description usePreserveSearchParams hook
  * Purpose of the function:
  * By first render check url params if it exist  it sets in localStorage and return it in searchParams. 
  * If url params not exist then hook gets these params from localStorage.
  *
  * @param {string} storageKey - It is a key of local storage which point where hook needs to set or get filters params.  
                                Each components which use this hook has unique storageKey.
                                Example: CashFlows.js has storageKey = 'cash-flow-filters'                       
  * @return {array}  - returns string searchParams with filters params and set function setSearchParams
 */

const usePreserveSearchParams = (storageKey) => {
  const history = useHistory();
  const preserveHistorySearch = localStorage.getItem(storageKey);
  const searchParams = new URLSearchParams(history.location.search || preserveHistorySearch);

  useEffect(() => {
    const historySearch = history.location.search;
    if (localStorage.getItem(storageKey) && !historySearch) {
      history.push(`?${localStorage.getItem(storageKey)}`);
    } else if (historySearch) {
      localStorage.setItem(storageKey, historySearch.slice(1));
    }
    // eslint-disable-next-line
  }, []);

  const setSearchParams = (key, value) => localStorage.setItem(key, value);

  return [searchParams, setSearchParams];
};

export default usePreserveSearchParams;
